window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('bootstrap');
    require('admin-lte');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * Bearer token.
 */

window.axios = require('axios');

const bearerToken = localStorage.getItem('access_token');

if (bearerToken) {
    window.axios.defaults.headers.common['Authorization'] = `Bearer ${bearerToken}`;
} else {
    console.warn('token not found');
}
